<script setup>
import { computed, ref, toValue } from 'vue'
import Uploads from '@/components/upload/uploads.vue'

const model = defineModel()
const props = defineProps({
  onAddFiles: Function,
  division: {
    type: String,
    required: true,
  },
  url: [String, null],
  label: {
    type: String,
    default: 'Документы и фотографии',
  },
})

const emit = defineEmits(['addFiles'])
const uploadUrl = computed(() => props.url || `complaints/${model.value?.id}/upload`)
const uploading = ref(false)

function _onAddFiles(hook) {
  const _hook = () => {
    uploading.value = true
    hook()
  }
  if (props.onAddFiles instanceof Function) {
    emit('addFiles', _hook)
  } else {
    _hook()
  }
}
function onDone(uploaded) {
  const ups = model.value.uploads || []
  uploading.value = false
  if (uploaded) {
    ups.push(toValue(uploaded))
  }
  model.value = { ...model.value, uploads: ups }
}
</script>
<template>
  <div>
    {{ label }}
    <Uploads
      v-model="model.uploads"
      #="{ add }"
      :url="uploadUrl"
      :division="division"
      @upload:done="onDone"
    >
      <button class="btn btn-link" type="button" @click="_onAddFiles(add)" :disabled="uploading">
        <i class="bi bi-file-earmark" />
        Загрузить документ
      </button>
    </Uploads>
  </div>
</template>
